import React from "react";
import FetchTVShows from "../../components/FetchTVShows/FetchTVShows";

const NowOnAirTVShows = () => {
  return <FetchTVShows slug="on_the_air" pageTitle="On The Air" />;
};

export default NowOnAirTVShows;
